import { Text } from 'braid-design-system';

import { CertsyToolTip } from 'src/components/common/Certsy/CertsyTooltip/CertsyTooltip';
import { TooltipSpanWrapper as TooltipTriggerWrapper } from 'src/components/common/Tooltip/TooltipTriggerWrapper';
import { STATUS_CERTIFIED } from 'src/constants/roleRequirementStatus';

import RoleRequirementIcon from '../RoleRequirementIcon';
import type { Verification } from '../types';

import VerificationTooltipContent from './VerificationTooltipContent';

interface Props {
  verifications: Verification[];
  status: string;
  isCardView: boolean;
  isMobile?: boolean;
  jobApplicationId: string;
}

export const RoleRequirementIconWithTooltip = ({
  jobApplicationId,
  verifications,
  status,
  isCardView,
  isMobile = false,
}: Props) => {
  const tooltipContent = (
    <VerificationTooltipContent
      verifications={verifications}
      jobApplicationId={jobApplicationId}
    />
  );

  if (status === STATUS_CERTIFIED && isCardView && !isMobile) {
    return (
      <CertsyToolTip
        tooltipContent={tooltipContent}
        placement="bottom-start"
        offset={[0, 5]}
        fallbackPlacements={['top-start', 'bottom-start']}
      >
        <TooltipTriggerWrapper>
          <Text>
            <RoleRequirementIcon status={STATUS_CERTIFIED} />
          </Text>
        </TooltipTriggerWrapper>
      </CertsyToolTip>
    );
  }
  return (
    <Text>
      <RoleRequirementIcon status={status} />
    </Text>
  );
};
